import {
  Alert,
  Badge,
  Box,
  Divider,
  DollarSignIcon,
  Flex,
  useTheme,
} from '@agrotoken-tech/ui';
import { PageHeader } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import { CropPledgeAside } from '../shared/CropPledgeAside';
import useCropPledgeDetail from './hooks/useCropPledgeDetail';
import { ApproveCropPledgeModal } from './modals/ApproveCropPledgeModal';
import MarkAsPaidModal from './modals/MarkAsPaidModal';
import { RejectCropPledgeModal } from './modals/RejectCropPledgeModal';

export const CropPledgeDetail = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const {
    userHasPendingChanges,
    setUserHasPendingChanges,
    sectionTitle,
    tabsDataAside,
    cropPledgeStatusIcons,
    cropPledgeStatusBadgeColors,
    headerActions,
    cropPledgeStatus,
    role,
    isOpenRejectModal,
    onCloseRejectModal,
    isOpenApproveModal,
    onCloseApproveModal,
    isOpenMarkAsPaidModal,
    onCloseMarkAsPaidModal,
    showLotsAmountAlert,
    lotsAmountAlertDesc,
  } = useCropPledgeDetail();

  return (
    <Flex flexDir={'column'}>
      <Box mb="28px">
        <PageHeader
          title={sectionTitle}
          badge={cropPledgeStatus?.statuses.map((status) => (
            <Badge
              mr="2"
              icon={cropPledgeStatusIcons[status]}
              colorScheme={cropPledgeStatusBadgeColors[status]}
              iconPosition="leading"
            >
              {t(`cropPledge.status.${status}`)}
            </Badge>
          ))}
          actions={headerActions}
        />
        {showLotsAmountAlert && (
          <Alert
            variant="gray"
            icon={DollarSignIcon}
            title={lotsAmountAlertDesc}
            mt={'28px'}
          />
        )}
      </Box>
      <Divider />
      <CropPledgeAside
        tabsData={tabsDataAside}
        theme={theme}
        hasUserPendingChanges={userHasPendingChanges}
        setUserHasPendingChanges={setUserHasPendingChanges}
        cropPledgeUserRole={role}
      />
      <RejectCropPledgeModal
        isOpen={isOpenRejectModal}
        onClose={onCloseRejectModal}
      />
      <ApproveCropPledgeModal
        isOpen={isOpenApproveModal}
        onClose={onCloseApproveModal}
      />
      <MarkAsPaidModal
        isOpen={isOpenMarkAsPaidModal}
        onClose={onCloseMarkAsPaidModal}
      />
    </Flex>
  );
};
